import React, { useEffect, useRef, useMemo, useState } from "react";
import { useSheetDataStore } from "../zustand/sheetDataStore";
import { useVisibility } from "./toggleMenu";
import useApiStore from "../store/apiStore";
//For dimention
import { findMax } from "../utils/numberUtils";
//
import humanLogo from "../img/outline-human-body-mens-figure-in-linear-style-the-outline-of-a-young-man-black-and-white-silho.png";
import electricite from "../img/pow-eth-icon.png";
import { useToolbar } from "../hook/ToolbarContext";
import DimensionGroup from "./DimensionGroup";
import DimensionItem from "./DimensionItem";
import InfoTable from "./InfoTable";
import { toggleClassOnTableInputs } from "../utils/printUtils";
import NotesEditor from "./NotesEditor"; // Import the new NotesEditor component

import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import DownloadIcon from "@mui/icons-material/Download";
import PreviewIcon from "@mui/icons-material/Preview";

// Calculate raw nicheDepth

// Force to nearest 1/8th inch (0.125)
// const roundToNearest4th = (num) => {
//   // Get the whole number part
//   const wholePart = Math.floor(num);

//   // Get the decimal part
//   const decimalPart = num - wholePart;

//   // The possible fractions (now only quarter fractions)
//   const fours = [0, 0.25, 0.5, 0.75, 1];

//   // Find the closest fraction
//   let closestFour = 0;
//   let minDifference = 1;

//   for (const eighth of fours) {
//     const difference = Math.abs(decimalPart - eighth);
//     if (difference < minDifference) {
//       minDifference = difference;
//       closestFour = eighth;
//     }
//   }

//   // If closest is 1, increment whole part and set fraction to 0
//   if (closestFour === 1) {
//     return wholePart + 1;
//   }

//   // Otherwise return whole part plus closest fraction
//   return wholePart + closestFour;
// };

// Get the rounded nicheDepth

const Canvas = ({ containerRef }) => {
  // Generate a unique component ID for the notes section
  const notesComponentId = "diagram-notes-editor";

  //Note related
  // Use the toolbar hook
  const toolbar = useToolbar(notesComponentId);

  // Enable toolbar for notes section on component mount
  useEffect(() => {
    toolbar.enable();
    // Cleanup will happen automatically when component unmounts
    return () => {
      toolbar.disable();
    };
  }, []);
  // Note done

  // Get visibility state from context with fallback values
  const { visibleElements = {} } = useVisibility();

  // Ensure we have default values if visibleElements is undefined
  const safeVisibility = {
    floorLine: true,
    centreLine: true,
    woodBacking: true,
    receptacleBox: true,
    intendedPosition: true,
    sideView: true,
    ...visibleElements,
  };

  // Destructure intendedPosition from safeVisibility
  const { intendedPosition } = safeVisibility;

  // Add constants for better maintainability
  const COLORS = {
    primary: "#000000",
    highlight: "#000000",
    accent: "#FFA500",
    background: "#ffffff",
    floorLine: "#000000", // Blue color for floor line
    measurement: "#CC3366", // Accent color for measurements
  };

  // Add font style constant
  const TEXT_STYLE = {
    fontFamily: 'Lato, sans-serif',
  };

  //SVG ref for coordinate conversion
  const svgRef = useRef(null);

  // Get all state and methods from the store
  const {
    isHorizontal,
    setStartDragInfo,
    updateBoxPosition,
    endDrag,
    receptacleBoxes,
    isNiche,
    floorDistance,
    selectedScreen,
    selectedMediaPlayer,
    updateBoundary,
    repositionBoxes,
    selectedMount,
    variantDepth,
    isEdgeToEdge,
    canDownload,
    setLedScaleFactor,
  } = useSheetDataStore();

  //Add these lines to get the apiStore functionality
  const { setNoteArea, noteArea } = useApiStore();
  const flatWallDepth = parseFloat(
    // (selectedScreen?.Depth || 0) + (selectedMount?.["Depth (in)"] || 0)
    parseFloat(selectedScreen?.Depth || 0) +
    parseFloat(
      findMax(
        selectedMediaPlayer?.Depth || 0,
        selectedMount ? selectedMount["Depth (in)"] : 0
      )
    ) - 0/2
  );
  // Dimension related
  // Calculate raw nicheDepth
  const rawNicheDepth =
    parseFloat(selectedScreen?.Depth || 0) +
    parseFloat(
      findMax(
        selectedMediaPlayer?.Depth || 0,
        selectedMount ? selectedMount["Depth (in)"] : 0
      )
    ) +
    parseFloat(variantDepth || 0);

  // Force to nearest 1/8th inch (0.125)
  // const roundToNearest4th = (num) => {
  //   // Get the whole number part
  //   const wholePart = Math.floor(num);

  //   // Get the decimal part
  //   const decimalPart = num - wholePart;

  //   // The possible fractions (now only quarter fractions)
  //   const quarters = [0, 0.25, 0.5, 0.75, 1];

  //   // Find the next quarter
  //   for (const quarter of quarters) {
  //     if (decimalPart <= quarter) {
  //       // If we're at the last quarter (1), increment whole part
  //       if (quarter === 1) {
  //         return wholePart + 1;
  //       }
  //       // Otherwise return the current quarter
  //       return wholePart + quarter;
  //     }
  //   }

  //   // If we get here, it means decimalPart is greater than 1
  //   // This shouldn't happen due to how decimalPart is calculated, but just in case
  //   return wholePart + 1;
  // };

  const roundToNearest4th = (num) => {
    // Get the whole number part
    const wholePart = Math.floor(num);
    
    // Get the decimal part
    const decimalPart = num - wholePart;
    
    // The possible fractions (now only quarter fractions)
    const quarters = [0, 0.25, 0.5, 0.75, 1];
    
    // Find the next quarter
    for (const quarter of quarters) {
      if (decimalPart <= quarter) {
        // If we're at the last quarter (1), increment whole part
        if (quarter === 1) {
          return wholePart + 1;
        }
        // Otherwise return the current quarter
        return wholePart + quarter;
      }
    }
    
    // If we get here, it means decimalPart is greater than 1
    // This shouldn't happen due to how decimalPart is calculated, but just in case
    return wholePart + 1;
  };

  // Get the rounded nicheDepth
  const nicheDepth = roundToNearest4th(rawNicheDepth);
  const flatDepth = roundToNearest4th(flatWallDepth);
  //Dimension end

  //Get dimensions from selected screen and parse as numbers
  const rawWidth = parseFloat(selectedScreen?.["Width"] || 0);
  const rawHeight = parseFloat(selectedScreen?.["Height"] || 0);
  const depth = parseFloat(selectedScreen?.["Depth"] || 0);

  // Determine width and height based on orientation
  // If vertical (isHorizontal = false), swap width and height
  const width = isHorizontal ? rawWidth : rawHeight;
  const height = isHorizontal ? rawHeight : rawWidth;

  // Calculate niche dimensions with proper margins
  const nicheWidthExtra = selectedMount?.["Clearance needed around screen"] || 0; // Add 1.5 or 2 inches on each side
  const nicheHeightExtra = selectedMount?.["Clearance needed around screen"] || 0;; // Add 1.5 or 2 inches on each side
  const nicheWidth = rawWidth + nicheWidthExtra;
  const nicheHeight = rawHeight + nicheHeightExtra;

  const DirnicheWidth = isHorizontal ? nicheWidth : nicheHeight;
  const DirnicheHeight = isHorizontal ? nicheHeight : nicheWidth;

  // Base dimensions for the diagram area
  const BASE_WIDTH = 800;
  const BASE_HEIGHT = 800;

  // Maximum dimensions for the screen in the SVG
  const MAX_SCREEN_WIDTH = 500;
  const MAX_SCREEN_HEIGHT = 400;

  // Fixed floor line position from the top of the SVG
  const FIXED_FLOOR_LINE_Y = 600; // This will be our fixed floor line position

  // Dynamic scaling factor based on screen size
  const widthScaleFactor = Math.min(10, MAX_SCREEN_WIDTH / Math.max(width, 1));
  const heightScaleFactor = Math.min(
    10,
    MAX_SCREEN_HEIGHT / Math.max(height, 1)
  );
  const SCALE_FACTOR = Math.min(widthScaleFactor, heightScaleFactor);

  // Update the store's scale factor whenever it changes
  useEffect(() => {
    setLedScaleFactor(SCALE_FACTOR);
  }, [SCALE_FACTOR, setLedScaleFactor]);

  // Calculate screen dimensions in pixels with adaptive scaling
  const screenWidthPx = Math.max(100, width * SCALE_FACTOR);
  const screenHeightPx = Math.max(100, height * SCALE_FACTOR);

  // Calculate niche dimensions in pixels
  const nicheWidthPx = screenWidthPx + nicheWidthExtra * 5;
  const nicheHeightPx = screenHeightPx + nicheHeightExtra * 5;


const NicheDimensionWidth = selectedScreen?.["Width"]
? (
    parseFloat(selectedScreen["Width"]) +
    (selectedMount["Clearance needed around screen"] || 0)
  ).toFixed(2)
: 0;

const NicheDimensionHeight = selectedScreen?.["Height"]
? (
    parseFloat(selectedScreen["Height"]) +
    (selectedMount["Clearance needed around screen"] || 0)
  ).toFixed(2)
: 0;

const NicheDimensionHeightRounded = roundToNearest4th(NicheDimensionHeight);
const NicheDimensionWidthRounded = roundToNearest4th(NicheDimensionWidth);



  // Calculate center positions - ensure we have enough margin on all sides
  const centerX = BASE_WIDTH / 2;
  // Adjust centerY to maintain proper distance from floor line
  const centerY = FIXED_FLOOR_LINE_Y - 300; // Position screen relative to fixed floor line

  // Calculate screen position (centered)
  const screenX = centerX - screenWidthPx / 2;
  const screenY = centerY - screenHeightPx / 2;

  // Calculate niche position (centered around screen)
  const nicheX = centerX - nicheWidthPx / 2;
  const nicheY = centerY - nicheHeightPx / 2;

  // Wood backing dimensions (slightly smaller than screen)
  const woodBackingMargin = isEdgeToEdge ? 5 : 30;
  const woodBackingX = screenX + woodBackingMargin;
  const woodBackingY = screenY + woodBackingMargin;
  const woodBackingWidth = screenWidthPx - woodBackingMargin * 2;
  const woodBackingHeight = screenHeightPx - woodBackingMargin * 2;

  // Side view dimensions - scaled with the screen depth but with minimum and maximum
  const sideViewX = screenX + screenWidthPx + 140;
  const sideViewY = screenY;
  const sideViewHeight = screenHeightPx;
  const sideViewDepth = Math.max(25, Math.min(50, depth * SCALE_FACTOR));

  // Use FIXED_FLOOR_LINE_Y instead of calculating floorLineY
  const floorLineY = FIXED_FLOOR_LINE_Y;

  //sideview
  const viewBoxWidth = Math.max(BASE_WIDTH, sideViewX + sideViewDepth + 60);

  // Set viewBoxHeight to be larger than FIXED_FLOOR_LINE_Y to ensure floor line is visible
  const viewBoxHeight = Math.max(FIXED_FLOOR_LINE_Y + 100, 700);

  // Update draggable boundary based on screen dimensions
  const draggableBoundary = useMemo(() => {
    return {
      x: screenX,
      y: screenY,
      width: screenWidthPx,
      height: screenHeightPx,
    };
  }, [screenX, screenY, screenWidthPx, screenHeightPx]);

  const MIN_FLOOR_DISTANCE = 5; // Minimum distance in inches
  const calculatedFloorDistance = Math.max(MIN_FLOOR_DISTANCE, floorDistance);

  // Effect to update the boundary in the store when screen dimensions change
  useEffect(() => {
    // Update the boundary in the store
    updateBoundary(draggableBoundary);

    // Reposition any boxes that are now outside the boundary
    repositionBoxes();
  }, [draggableBoundary, updateBoundary, repositionBoxes]);

  // Effect to adjust SVG viewBox when floor distance changes
  // This ensures the diagram properly scales when the floor line moves
  useEffect(() => {
    if (svgRef.current) {
      // Force SVG to update its viewBox when floorDistance changes
      const currentViewBox = svgRef.current.getAttribute("viewBox");
      svgRef.current.setAttribute("viewBox", currentViewBox);
    }
  }, [floorDistance, viewBoxHeight]);
  //Convert client coordinates to SVG coordinates
  const clientToSVGCoordinates = (clientX, clientY) => {
    if (!svgRef.current) return { x: 0, y: 0 };
    const ctm = svgRef.current.getScreenCTM();
    if (!ctm) return { x: 0, y: 0 };

    const svgPoint = svgRef.current.createSVGPoint();
    svgPoint.x = clientX;
    svgPoint.y = clientY;

    const point = svgPoint.matrixTransform(ctm.inverse());
    return { x: point.x, y: point.y };
  };

  // Start dragging
  const startDrag = (event, id) => {
    event.preventDefault();

    if (!svgRef.current) return;

    const box = receptacleBoxes.find((box) => box.id === id);
    if (!box) return;

    const point = clientToSVGCoordinates(event.clientX, event.clientY);
    setStartDragInfo(id, point, { x: box.x, y: box.y });

    document.addEventListener("mousemove", handleDrag);
    document.addEventListener("mouseup", handleMouseUp);
  };

  // Handle drag
  const handleDrag = (event) => {
    const point = clientToSVGCoordinates(event.clientX, event.clientY);
    updateBoxPosition(point);
  };

  // End dragging
  const handleMouseUp = () => {
    endDrag();
    document.removeEventListener("mousemove", handleDrag);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  // Clean up event listeners on unmount
  useEffect(() => {
    return () => {
      document.removeEventListener("mousemove", handleDrag);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  // Draw the boundary box for debugging (comment out in production)
  const showBoundaryBox = false; // Set to true to see the boundary

  // Determine what text to display for dimensions
  const widthLabel = isHorizontal ? "Width" : "Height";
  const heightLabel = isHorizontal ? "Height" : "Width";

  // Get raw dimension values for labels
  const rawWidthValue = rawWidth.toFixed(2);
  const rawHeightValue = rawHeight.toFixed(2);



  // Zoom Buttons -----------------------------------------
  const [scale, setScale] = useState(1);
  const zoomIn = () => setScale((prev) => Math.min(prev + 0.1, 2));
  const zoomOut = () => setScale((prev) => Math.max(prev - 0.1, 0.5));
  const resetZoom = () => setScale(1);
  // Zoom Buttons -----------------------------------------

  const showSections = canDownload();

  // const handleFullScreenPreview = async () => {
  //   try {
  //     const bc = document.getElementById("bottom_container");

  //     // Apply print-specific styles
  //     toggleClassOnTableInputs("table_input", "bottom-3", true);
  //     toggleClassOnTableInputs("table_input_td", "pb-3", true);
  //     toggleClassOnTableInputs("p_print", "pb-3", true);
  //     bc.classList.remove("h-40");
  //     bc.classList.add("h-64");
  //     bc.classList.remove("mb-1");
  //     bc.classList.add("mb-3");
  //     containerRef.current.classList.add("pb-8");

  //     if (!containerRef.current) {
  //       throw new Error("Container element not found");
  //     }

  //     // Create a new window for full-screen preview
  //     const previewWindow = window.open("", "_blank");
  //     previewWindow.document.write(`
  //       <!DOCTYPE html>
  //       <html>
  //         <head>
  //           <title>Drawing Preview</title>
  //           <style>
  //             @media screen {
  //               body {
  //                 margin: 0;
  //                 padding: 0;
  //                 display: flex;
  //                 justify-content: center;
  //                 align-items: center;
  //                 min-height: 100vh;
  //                 background-color: #f0f0f0;
  //                 -webkit-user-select: text;
  //                 user-select: text;
  //               }
  //               .preview-container {
  //                 position: relative;
  //                 width: 100%;
  //                 max-width: 1200px;
  //                 height: 100vh;
  //                 box-shadow: 0 0 10px rgba(0,0,0,0.2);
  //                 background: white;
  //                 padding: 20px;
  //                 box-sizing: border-box;
  //                 overflow: auto;
  //                 -webkit-user-select: text;
  //                 user-select: text;
  //               }
  //               .preview-content {
  //                 width: 100%;
  //                 height: 100%;
  //                 position: relative;
  //                 background: white;
  //                 -webkit-user-select: text;
  //                 user-select: text;
  //               }
  //               .preview-content svg {
  //                 width: 100%;
  //                 height: auto;
  //                 max-height: 70vh;
  //                 -webkit-user-select: text;
  //                 user-select: text;
  //               }
  //               .preview-content * {
  //                 -webkit-user-select: text;
  //                 user-select: text;
  //               }
  //               .preview-content input,
  //               .preview-content textarea {
  //                 -webkit-user-select: text;
  //                 user-select: text;
  //                 pointer-events: auto;
  //               }
  //               .preview-content [contenteditable="true"] {
  //                 -webkit-user-select: text;
  //                 user-select: text;
  //                 pointer-events: auto;
  //               }
  //             }
              
  //             @media print {
  //               body {
  //                 margin: 0;
  //                 padding: 0;
  //                 background: white;
  //                 -webkit-user-select: text;
  //                 user-select: text;
  //               }
  //               .preview-container {
  //                 width: 100%;
  //                 height: auto;
  //                 box-shadow: none;
  //                 background: white;
  //                 padding: 0;
  //                 margin: 0;
  //                 overflow: visible;
  //                 page-break-after: avoid;
  //                 -webkit-user-select: text;
  //                 user-select: text;
  //               }
  //               .preview-content {
  //                 width: 100%;
  //                 height: auto;
  //                 position: static;
  //                 background: white;
  //                 display: block;
  //                 -webkit-user-select: text;
  //                 user-select: text;
  //               }
  //               .preview-content svg {
  //                 width: 100%;
  //                 height: auto;
  //                 max-height: none;
  //                 page-break-inside: avoid;
  //                 -webkit-user-select: text;
  //                 user-select: text;
  //               }
  //               .preview-content * {
  //                 -webkit-user-select: text;
  //                 user-select: text;
  //               }
  //             }
  //             ${Array.from(document.styleSheets)
  //               .map((sheet) => {
  //                 try {
  //                   return Array.from(sheet.cssRules)
  //                     .map((rule) => rule.cssText)
  //                     .join("\n");
  //                 } catch (e) {
  //                   return "";
  //                 }
  //               })
  //               .join("\n")}
  //           </style>
  //         </head>
  //         <body>
  //           <div class="preview-container">
  //             <div class="preview-content">
  //               ${containerRef.current.outerHTML}
  //             </div>
  //           </div>
  //         </body>
  //       </html>
  //     `);
  //     previewWindow.document.close();
  //   } catch (error) {
  //     console.error("Error generating preview:", error);
  //   } finally {
  //     // Reset styles
  //     const bc = document.getElementById("bottom_container");
  //     if (bc) {
  //       toggleClassOnTableInputs("table_input", "bottom-3", false);
  //       toggleClassOnTableInputs("table_input_td", "pb-3", false);
  //       toggleClassOnTableInputs("p_print", "pb-3", false);
  //       bc.classList.remove("h-64");
  //       bc.classList.add("h-40");
  //       bc.classList.remove("mb-3");
  //       bc.classList.add("mb-1");
  //       containerRef.current.classList.remove("pb-8");
  //     }
  //   }
  // };

  return (
    <>
      {/* Zoom Buttons */}
      <div className="fixed top-16 left-5 z-10 bg-white p-2 rounded shadow">
        <button onClick={zoomIn} className="px-3 py-1 bg-gray-200 rounded">
          +
        </button>
        <button
          onClick={resetZoom}
          className="px-3 py-1 bg-gray-200 rounded mx-2"
        >
          Reset
        </button>
        <button onClick={zoomOut} className="px-3 py-1 bg-gray-200 rounded">
          -
        </button>
      </div>
      <div className="overflow-auto w-full h-screen pt-14 lg:pr-80 pr-0 top-0 bg-gray-200 relative">
        {/* Main Drawing Container */}
        <div
          ref={containerRef}
          className="v-container w-[1056px] border h-[816px] p-4 flex flex-col justify-between gap-4 bg-white print:w-[816px] print:h-[1056px] print:m-0 print:p-0"
          style={{
            transform: `translate(calc(-50% - 120px), -50%) scale(${scale})`,
            position: "absolute",
            top: "52%",
            left: "50%",
          }}
        >
          {showSections ? (
            <>
              {/* Upper Section */}
              <div className="v-upper-section flex-1 flex flex-row justify-between print:p-2">
                <div className="v-upper-section-left flex justify-center flex-1 items-center">
                  {/* Main Content Area 111111111111111111111111 */}
                  <div className="flex justify-end relative bg-opacity-30 max-w-[1200px] max-h-[1200px] h-full">
                    {/* LED Video Wall Intended Position */}

                    <svg
                      ref={svgRef}
                      width="100%"
                      height="115%"
                      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
                      preserveAspectRatio="xMidYMid meet"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ touchAction: "none" }}
                    >
                      <title>LED Display Installation Diagram</title>
                      <desc>
                        Technical diagram showing LED display mounting
                        specifications and measurements
                      </desc>

                      {/* Grid background */}
                      <defs>
                        <pattern
                          id="grid"
                          width="50"
                          height="50"
                          patternUnits="userSpaceOnUse"
                        >
                          <path
                            d="M 50 0 L 0 0 0 50"
                            fill="none"
                            stroke="#CCCCCC"
                            strokeWidth="0.5"
                          />
                        </pattern>
                      </defs>
                      <rect
                        width="100%"
                        height="100%"
                        fill="url(#grid)"
                        opacity="0.1"
                      />

                      {/* Draggable boundary visualization (for debugging) */}
                      {showBoundaryBox && (
                        <rect
                          x={draggableBoundary.x}
                          y={draggableBoundary.y}
                          width={draggableBoundary.width}
                          height={draggableBoundary.height}
                          fill="none"
                          stroke="red"
                          strokeWidth="1"
                          strokeDasharray="5,5"
                        />
                      )}

{safeVisibility.woodBacking && (
                        <>
                          <rect
                            x={woodBackingX}
                            y={woodBackingY}
                            width={woodBackingWidth}
                            height={woodBackingHeight}
                            fill="#f4f2f2"
                            stroke="black"
                            strokeDasharray="8,8"
                            strokeWidth="1"
                          />
                          {isEdgeToEdge ? (
                            // Edge to Edge indicators
                            <>
                              <circle
                                cx={woodBackingX + 20}
                                cy={woodBackingY + 20}
                                r="4"
                                fill="black"
                                stroke="black"
                              />
                              <line
                                x1={woodBackingX + 20}
                                y1={woodBackingY + 20}
                                x2={woodBackingX + 20}
                                y2={screenY - 60}
                                stroke="black"
                                strokeWidth="1"
                              />
                               <line
                                x1={woodBackingX + 20}
                                y1={woodBackingY - 65}
                                x2={woodBackingX - 40}
                                y2={woodBackingY - 65}
                                stroke="black"
                                strokeWidth="1"
                              />
                              <text
                                x={woodBackingX - 155}
                                y={screenY - 50}
                                fontSize="18"
                               fontWeight="300"
                              >
                                Woodbacking
                              </text>
                              <text
                                x={woodBackingX - 147}
                                y={screenY -30}
                                fontSize="18"
                                fontWeight="300"
                              >
                                (See Notes)
                              </text>
                              {/* <line
                                x1={woodBackingX + 20}
                                y1={woodBackingY}
                                x2={woodBackingX + 20}
                                y2={screenY - 130}
                                stroke="black"
                                strokeWidth="1"
                              
                              /> */}
                            </>
                          ) : (
                            // Standard wood backing indicators
                            <>
                              <circle
                                cx={woodBackingX + 20}
                                cy={woodBackingY + 20}
                                r="4"
                                fill="black"
                                stroke="black"
                              />
                              <line
                                x1={woodBackingX + 20}
                                y1={woodBackingY + 20}
                                x2={woodBackingX + 20}
                                y2={screenY - 90}
                                stroke="black"
                                strokeWidth="1"
                              />
                               <line
                                x1={woodBackingX + 20}
                                y1={woodBackingY - 120}
                                x2={woodBackingX - 37}
                                y2={screenY - 90}
                                stroke="black"
                                strokeWidth="1"
                              />
                              <text
                                x={woodBackingX - 155}
                                y={screenY - 80}
                                fontSize="18"
                                fontWeight="300"
                              >
                                Wood Backing
                              </text>
                              <text
                                x={woodBackingX - 147}
                                y={screenY - 55}
                                fontSize="18"
                             fontWeight="300"
                              >
                                (See Notes)
                              </text>
                            </>
                          )}
                        </>
                      )}


     {/* Receptacle Boxes - NOT draggable */}
     {safeVisibility.receptacleBox &&
                        receptacleBoxes.map((box, index) => {
                          // Ensure all values are valid numbers
                          const boxX = parseFloat(box.x) || 0;
                          const boxY = parseFloat(box.y) || 0;
                          const boxWidth = parseFloat(box.width) || 0;
                          const boxHeight = parseFloat(box.height) || 0;

                          return (
                            <g key={box.id}>
                              <rect
                                x={boxX}
                                y={boxY}
                                width={boxWidth}
                                height={boxHeight}
                                fill={COLORS.background}
                                stroke={COLORS.highlight}
                                strokeWidth="1.5"
                                strokeDasharray="4"
                              />
                              {/* Electricity Symbol */}
                              <image
                                href={electricite}
                                x={boxX + boxWidth * 0.1}
                                y={boxY + boxHeight * 0.1}
                                width={boxWidth * 0.9}
                                height={boxHeight * 0.9}
                                preserveAspectRatio="xMidYMid meet"
                                opacity="0.9"
                              />
                            </g>
                          );
                        })}
                      {/* Human figure for scale reference */}
                      {/* <image 
                        href={humanLogo} 
                        x={humanX}
                        y={humanY}
                        height={humanHeight}
                        width={humanWidth}
                        preserveAspectRatio="xMidYMid meet"
                      /> */}

                      {/* Niche (outer box) - only visible if isNiche is true */}
                      {isNiche && (
                        <>
                          {/* Niche rectangle - dynamically sized */}

                          <line
                        x1={nicheX + nicheWidthPx + 30}
                        y1={nicheY + 6}
                        x2={nicheX + nicheWidthPx + 30}
                        y2={nicheY + nicheHeightPx - 6}
                        stroke="black"
                        strokeWidth="1"
                        markerStart="url(#arrowReversed)"
                        markerEnd="url(#arrow)"
                      />
                          <rect
                            x={nicheX}
                            y={nicheY}
                            width={nicheWidthPx}
                            height={nicheHeightPx}
                            fill="none"
                            stroke="black"
                            strokeWidth="1"
                          />

                          {/* Bottom measurement for niche */}
                          <line
                            x1={nicheX + 6}
                            y1={nicheY + nicheHeightPx + 40}
                            x2={nicheX + nicheWidthPx - 6}
                            y2={nicheY + nicheHeightPx + 40}
                            stroke="black"
                            strokeWidth="1"
                            markerStart="url(#arrowReversed)"
                            markerEnd="url(#arrow)"
                          />

                          <line
                            x1={nicheX}
                            y1={nicheY + nicheHeightPx + 6}
                            x2={nicheX}
                            y2={nicheY + nicheHeightPx + 50}
                            stroke="black"
                            strokeWidth=".5"
                          />
                          <line
                            x1={nicheX + nicheWidthPx}
                            y1={nicheY + nicheHeightPx + 5}
                            x2={nicheX + nicheWidthPx}
                            y2={nicheY + nicheHeightPx + 50}
                            stroke="black"
                            strokeWidth=".5"
                          />

                          <text
                            x="370"
                            y={nicheY + nicheHeightPx + 59}
                            textAnchor="middle"
                            fontSize="18"
                            fontFamily=""
                            fontWeight="300"
                          >
                           {  
                           isHorizontal ?
                           NicheDimensionWidthRounded
                           :
                           NicheDimensionHeightRounded
                           }&quot;
                          </text>
                          <text
                            x="370"
                            y={nicheY + nicheHeightPx + 80}
                            textAnchor="middle"
                            fontSize="18"
                            fontWeight="200"
                            letterSpacing="1px"
                          >
                            (Width)
                          </text>

                          {/* RIGHT measurement for niche height (NEW POSITION) */}
                          <line
                            x1={nicheX + nicheWidthPx}
                            y1={nicheY}
                            x2={sideViewX - 86}
                            y2={nicheY}
                            stroke="black"
                            strokeWidth=".5"
                          />
                          <line
                            x1={nicheX + nicheWidthPx}
                            y1={nicheY + nicheHeightPx}
                            x2={sideViewX - 86}
                            y2={nicheY + nicheHeightPx}
                            stroke="black"
                            strokeWidth=".5"
                          />

                          {/* Height label on right side */}
                          <text
                            x={sideViewX - 57}
                            y={centerY - 30}
                            textAnchor="middle"
                            fontSize="18"
                            fontWeight="300"
                            transform="rotate(270, sideViewX - 35, centerY)"
                          >
                            {   
                            isHorizontal ?
                            NicheDimensionHeightRounded
                            :
                              NicheDimensionWidthRounded
                            }&quot;
                            <tspan x={sideViewX - 57} dy="14" y={centerY - 22}>
                              (Height)
                            </tspan>
                          </text>
                        </>
                      )}

                      {/* Side view - always visible */}
                      {/* Gray background for side view */}
                      {safeVisibility.sideView && (
                        <>
                        <rect
                        x={sideViewX}
                        y={sideViewY}
                        width={sideViewDepth + 6}
                        height={sideViewHeight}
                        fill="#CCCCCC"
                        stroke="none"
                        opacity="1"
                      />
                      <text
                        x={sideViewX + sideViewDepth / 2 + 5}
                        y={sideViewY + sideViewHeight + 65}
                        textAnchor="middle"
                        fontSize="18"
                        fontWeight="300"
                      >
                        {isNiche ? nicheDepth.toFixed(2) : flatDepth.toFixed(2)}&quot;
                      </text>
                      <text
                      
                      x={sideViewX + sideViewDepth / 2 - 25}
                      y={sideViewY + sideViewHeight + 83}
                      fontWeight="300"
                      fontSize="18"
                      >
                        (Depth)
                        </text>
                      {nicheDepth.toFixed(3)}
                      <line
                        x1={sideViewX}
                        y1={sideViewY}
                        x2={sideViewX}
                        y2={sideViewY + sideViewHeight}
                        stroke="black"
                        strokeWidth="1"
                      />
                      <line
                        x1={sideViewX + sideViewDepth}
                        y1={sideViewY}
                        x2={sideViewX + sideViewDepth}
                        y2={sideViewY + sideViewHeight}
                        stroke="black"
                        strokeWidth="1"
                      />
                      <line
                        x1={sideViewX + sideViewDepth + 6}
                        y1={sideViewY}
                        x2={sideViewX + sideViewDepth + 6}
                        y2={sideViewY + sideViewHeight}
                        stroke="black"
                        strokeWidth="1"
                      />

                      {/* Top and bottom lines of side view */}
                      <line
                        x1={sideViewX}
                        y1={sideViewY}
                        x2={sideViewX + sideViewDepth}
                        y2={sideViewY}
                        stroke="black"
                        strokeWidth="1"
                      />
                      <line
                        x1={sideViewX}
                        y1={sideViewY + sideViewHeight}
                        x2={sideViewX + sideViewDepth}
                        y2={sideViewY + sideViewHeight}
                        stroke="black"
                        strokeWidth="1"
                      />
                      <line
                        x1={sideViewX + sideViewDepth}
                        y1={sideViewY + sideViewHeight}
                        x2={sideViewX + sideViewDepth + 6}
                        y2={sideViewY + sideViewHeight}
                        stroke="black"
                        strokeWidth="1"
                      />
                      <line
                        x1={sideViewX + sideViewDepth}
                        y1={sideViewY}
                        x2={sideViewX + sideViewDepth + 6}
                        y2={sideViewY}
                        stroke="black"
                        strokeWidth="1"
                      />

                   

                      {/* Side view dimension lines - always visible */}
                      <line
                        x1={sideViewX}
                        y1={sideViewY + sideViewHeight + 5}
                        x2={sideViewX}
                        y2={sideViewY + sideViewHeight + 47}
                        stroke="black"
                        strokeWidth=".5"
                      />
                      <line
                        x1={sideViewX + sideViewDepth + 7}
                        y1={sideViewY + sideViewHeight + 5}
                        x2={sideViewX + sideViewDepth + 7}
                        y2={sideViewY + sideViewHeight + 47}
                        stroke="black"
                        strokeWidth=".5"
                      />
                      <line
                        x1={sideViewX + 2}
                        y1={sideViewY + sideViewHeight + 40}
                        x2={sideViewX + sideViewDepth + 4}
                        y2={sideViewY + sideViewHeight + 40}
                        stroke="black"
                        strokeWidth="1"
                        markerStart="url(#arrowReversed)"
                        markerEnd="url(#arrow)"
                      />
                      </>
                      )}
                      

                      {/* Main Rectangle - Screen (dynamically sized) */}
                      <rect
                        x={screenX}
                        y={screenY}
                        width={screenWidthPx}
                        height={screenHeightPx}
                        fill="none"
                        stroke="black"
                        strokeWidth="2"
                        opacity="1"
                      />

                      {/* Centerlines - only within screen boundaries */}
                      {safeVisibility.centreLine && (
                        <>
                        
                          {/* Horizontal centerline - constrained to screen */}
                          <line
                            x1={screenX - 40}
                            y1={centerY}
                            x2={screenX + screenWidthPx + 40}
                            y2={centerY}
                            stroke="black"
                            strokeWidth="1"
                            strokeDasharray="12"
                          />
                            <text
                       fontSize="22"
                       fontWeight="300"
                           x={screenX -58}
                           y={centerY}
                        className="centerline-text"
                           >
                           &#8452;
                          </text>
  {/* Vertical centerline - constrained to screen */}
  <line
                            x1={centerX}
                            y1={screenY - 40}
                            x2={centerX}
                            y2={screenY + screenHeightPx + 40}
                            stroke="black"
                            strokeWidth="1"
                            strokeDasharray="12"
                          />


                          <text
                       fontSize="22"
                       fontWeight="300"
                       textAnchor="middle"
                           x={centerX - 2}
                           y={screenY - 46}
                           className="centerline-text"
                           >
                           &#8452;
                          </text>
                        </>
                      )}
                      {intendedPosition && (
                        <>
                          <circle
                            cx={centerX}
                            cy={centerY}
                            r="5"
                            fill="none"
                            stroke="black"
                          />
                          <circle
                            cx={centerX}
                            cy={centerY}
                            r="3"
                            fill="yellow"
                            stroke="black"
                          />
                          <line
                            x1={centerX}
                            y1={centerY}
                            x2="435"
                            y2="53"
                            stroke="black"
                            strokeWidth="1"
                          />
                          <line
                            x1="435"
                            y1="53"
                            x2="453"
                            y2="53"
                            stroke="black"
                            strokeWidth="1"
                          />

                       
                          <text x="653" y="57" textAnchor="end" fontSize="18" fontWeight="300">
                            Intended Screen Position
                          </text>
                        </>
                      )}
                      {/* Wood Backing - Inner rectangle (only if visible) */}
                    

                 

                      {/* Circle Marker Definition */}
                      <defs>
                        <marker
                          id="circle"
                          markerWidth="10"
                          markerHeight="10"
                          refX="5"
                          refY="5"
                          orient="auto"
                        >
                          <circle cx="5" cy="5" r="3" fill="black" />
                        </marker>
                      </defs>

                      {/* Top measurement for screen width */}

                      {!isNiche && (
                        <>
                          <line
                            x1={screenX + 6}
                            y1={screenY - 40}
                            x2={screenX + screenWidthPx - 6}
                            y2={screenY - 40}
                            stroke="black"
                            strokeWidth="1"
                            markerStart="url(#arrowReversed)"
                            markerEnd="url(#arrow)"
                          />
                          <line
                            x1={screenX}
                            y1={screenY - 50}
                            x2={screenX}
                            y2={screenY - 12}
                             stroke="black"
                            strokeWidth="0.5"
                          />
                          <line
                            x1={screenX + screenWidthPx}
                            y1={screenY - 50}
                            x2={screenX + screenWidthPx}
                            y2={screenY - 12}
                            stroke="black"
                            strokeWidth="0.5"
                          />

                          <text
                            x={centerX - 50}
                            y={screenY - 70}
                            textAnchor="middle"
                            fontSize="18"
                            fontWeight="300"
                          >
                            {isHorizontal ? rawWidthValue : rawHeightValue}&quot;
                           
                          </text>
<text
textAnchor="middle"
  x={centerX - 50}
  y={screenY - 50}
 fontSize="18"
                            fontWeight="300"
>
  (Width)
</text>
                          {/* LEFT side measurement for screen height (moved from right) */}
                          <line
                            x1={screenX - 40}
                            y1={screenY + 6}
                            x2={screenX - 40}
                            y2={screenY + screenHeightPx - 6}
                            stroke="black"
                            strokeWidth="1"
                            markerStart="url(#arrowReversed)"
                            markerEnd="url(#arrow)"
                          />

                          <line
                            x1={screenX - 50}
                            y1={screenY}
                            x2={screenX - 12}
                            y2={screenY}
                            stroke="black"
                            strokeWidth=".5"
                          />
                          <line
                            x1={screenX - 50}
                            y1={screenY + screenHeightPx}
                            x2={screenX - 12}
                            y2={screenY + screenHeightPx}
                            stroke="black"
                            strokeWidth=".5"
                          />

                          <text
                            x={screenX - 70}
                            y={centerY - 87}
                            textAnchor="middle"
                            fontSize="18"
                            fontWeight="300"
                            transform="rotate(270, screenX - 75, centerY)"
                          >
                            {isHorizontal ? rawHeightValue + "''" : rawWidthValue + "''"}
                            <tspan x={screenX - 73} dy="14" y={centerY - 80}>
                              (Height)
                            </tspan>
                          </text>
                        </>
                      )}


                      {/* Floor Line Measurement */}
                      {safeVisibility.floorLine && (
                        <>
                          {/* Measurement line with zigzag break - proper scaling for small screens */}
                          {/* Top portion of line */}

                  
                      <line
                        x1="90"
                        y1={FIXED_FLOOR_LINE_Y}
                        x2="700"
                        y2={FIXED_FLOOR_LINE_Y}
                        stroke={COLORS.floorLine}
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                          <line
                            x1="90"
                            y1={centerY + 7}
                            x2="90"
                            y2={centerY + 50}
                            stroke="black"
                            strokeWidth="1.5"
                            markerStart="url(#arrowReversed)"
                          />

                          {/* Zigzag break in the middle - with dynamic spacing based on total distance */}
                          <polyline
                            points={`90,${centerY + 50} 
                          80,${centerY + 60} 
                          100,${centerY + 70} 
                          80,${centerY + 80} 
                          100,${centerY + 90} 
                          `}
                            stroke="black"
                            fill="transparent"
                            strokeWidth="1.5"
                          />

                          {/* Bottom portion of line - connect directly to floor line */}
                          <line
                            x1="90"
                            y1={centerY + 100}
                            x2="90"
                            y2={floorLineY - 3}
                            stroke="black"
                            strokeWidth="1.5"
                            markerEnd="url(#arrow)"
                          />

                          {/* Break symbol text - rotated 90 degrees */}
                          {/* <text
                            x="-8"
                            y={centerY + 142}
                            fontSize="8"
                            fill={COLORS.measurement}
                            transform={`rotate(90, 105, ${centerY + 130})`}
                          >
                            Not to scale
                          </text> */}

                          {/* Distance measurement */}
                          <g>
                            {/* Measurement text */}
                            <text
                              x="59"
                              y={(centerY + floorLineY) / 2}
                              textAnchor="middle"
                              fontSize="16"
                            fontWeight="300"
                             
                            >
                              {floorDistance + "''"} 
                            </text>
                            <text
                              x="53"
                              y={(centerY + floorLineY) / 2 + 20}
                              textAnchor="middle"
                              fontSize="16"
                              fontWeight="200"
                             
                            >
                              Distance 
                            </text>
                            <text
                              x="55"
                              y={(centerY + floorLineY) / 2 + 40}
                              textAnchor="middle"
                              fontSize="16"
                              fontWeight="200"
                            
                            >
                              to the
                            </text>
                            <text
                              x="53"
                              y={(centerY + floorLineY) / 2 + 60}
                              textAnchor="middle"
                              fontSize="16"
                              fontWeight="200"
                            >
                               Floor Line
                            </text>
                          </g>

                          {/* Floor line label */}
                          <text
                            x="40"
                            y={floorLineY}
                            textAnchor="middle"
                            fontSize="18"
                            fontWeight="300"
                          >
                            Floor Line
                          </text>

                          {/* Visual indicator markers with animations */}
                          {/* <circle
                            cx="90"
                            cy={centerY}
                            r="4"
                            fill={COLORS.measurement}
                          >
                            <animate
                              attributeName="r"
                              values="3;5;3"
                              dur="2s"
                              repeatCount="indefinite"
                            />
                          </circle> */}
                          {/* <circle
                            cx="90"
                            cy={floorLineY}
                            r="4"
                            fill={COLORS.measurement}
                          >
                            <animate
                              attributeName="r"
                              values="3;5;3"
                              dur="2s"
                              repeatCount="indefinite"
                            />
                          </circle> */}
                        </>
                      )}

                      {/* Arrow Definitions */}
                      <defs>
                        <marker
                          id="arrow"
                          viewBox="0 0 10 10"
                          refX="10"
                          refY="5"
                          markerWidth="5"
                          markerHeight="5"
                          orient="auto"
                        >
                          <path d="M0,0 L10,5 L0,10 z" fill="black" />
                        </marker>
                        <marker
                          id="arrowReversed"
                          viewBox="0 0 10 10"
                          refX="0"
                          refY="5"
                          markerWidth="5"
                          markerHeight="5"
                          orient="auto"
                        >
                          <path d="M10,0 L0,5 L10,10 z" fill="black" />
                        </marker>
                      </defs>
                    </svg>
                    {/* Center line */}
                  </div>
                </div>
                {/* Dimension Boxes Area 22222222222222222222222*/}
                {/* if (rawNicheDepth) //////////////////////////////////////////*/}
                {rawNicheDepth && selectedScreen ? (
                  <div className="v-dimension-boxes-container m-0 w-1/6 p-1 max-w-72">
                    <div className="v-dimension-boxes w-full flex flex-col space-y-4 ">
                      <div className="v-dimension-box1 border border-black p-2 bg-white bg-opacity-30 w-full h-[168px]">
                        <div className="font-bold text-sm h-26 pb-2">
                          <DimensionGroup
                            title="Screen Dimensions"
                            className="w-full"
                          >
                            <DimensionItem
                              label="Height"
                              value={`${isHorizontal ? selectedScreen["Height"] || 0 : selectedScreen["Width"] || 0}"`}
                              //selectedScreen["Height"] || 0
                              className="flex flex-row items-center justify-between  border-black h-5"
                            />
                            <DimensionItem
                              label="Width"
                              value={`${isHorizontal ? selectedScreen["Width"] || 0 : selectedScreen["Height"] || 0}"`}
                              className="flex flex-row items-center justify-between  border-black h-5"
                            />
                            <DimensionItem
                              label="Depth"
                              value={`${selectedScreen["Depth"] || 0}"`}
                              className="flex flex-row items-center justify-between  border-black mb-4"
                            />
                         
                          </DimensionGroup>
                         
                        </div>
                        <ul className="v-dimension-box1-list flex flex-row items-center justify-aroumd gap-1 justify-center mt-[-3px]">
                          <div className="mb-6 w-1 h-1 rounded-full bg-black"></div>
                        <li className="text-sm font-light mb-6 ">For installer use only</li>
                        </ul>
                      </div>

                      {/* Niche Dimensions Box */}
                      {isNiche && (
                        <div className="v-dimension-box2 border border-black p-2 bg-white bg-opacity-30 w-full h-26">
                          <div className="font-bold text-sm h-26 pb-2">
                            <DimensionGroup
                              title="Niche Dimensions"
                              className="w-full"
                            >
                              <DimensionItem
                                label="Height"
                                value={`${isHorizontal ? NicheDimensionHeightRounded : NicheDimensionWidthRounded}"`}
                                className="items-center text-center justify-between border-black h-5"
                              />
                              <DimensionItem
                                label="Width"
                                value={
                                `${isHorizontal ? NicheDimensionWidthRounded : NicheDimensionHeightRounded}"`
                                }
                                className="flex flex-row items-center justify-between  border-black h-5"
                              />
                              <DimensionItem
                                label="Depth"
                                value={`${nicheDepth.toFixed(2)}"`}
                                className="flex flex-row items-center justify-between border-black h-5"
                              />
                            </DimensionGroup>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>
            </>
          ) : (
            // Show this when no valid selections are made
            <div className="flex-1 flex items-center justify-center">
              <div className="text-center text-gray-500">
                <p className="text-2xl font-semibold mb-4">
                  Welcome to LED Technical Map
                </p>
                <p className="text-lg">
                  Please select both a Screen and Mount option to view the
                  layout
                </p>
              </div>
            </div>
          )}

          {/* Bottom Row - Notes and Table -----------------------------------------------------*/}
          <div
            className=" v-bottom-row flex space-x-6  print:h-44 print:mx-2 print:mb-2"
            id="bottom_container"
          >
            {/* Notes Section - REPLACED with NotesEditor component */}
            <div className="v-notes-section flex-1  border-[1px] border-black  bg-opacity-30 p-2">
              <NotesEditor className="v-notes-editor-component" componentId={notesComponentId} />
            </div>
            <div className="v-info-table flex-1 bg-opacity-30 border-[1px] border-black">
              <InfoTable />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Canvas;
